import { defineAsyncComponent } from "vue";
import { getI18n } from "@editor/ui-utils";
const de = {
  newsletterApi: {
    createAlreadyExists: "Newsletter kann nicht erstellt werden, da bereits ein Newsletter mit diesem Namen existiert",
    updateAlreadyExists: "Newsletter kann nicht aktualisiert werden, da bereits ein Newsletter mit diesem Namen existiert",
    created: "Newsletter erstellt",
    updated: "Newsletter aktualisiert",
    notFound: "Newsletter nicht gefunden",
    requiredFields: "Sie können den Newsletter nicht speichern, da obligatorische Informationen fehlen"
  },
  newsletterList: {
    newButton: "Neues Newsletter-Widget",
    name: "Suche nach Bezeichnung",
    deleteNewsletter: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade Newsletter",
    headerLabel: "Bezeichnung",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createNewsletter: "Newsletter erstellen",
    newsletterWidgetName: "Newsletter-Widget-Name",
    newsletterRecipientGroup: "Newsletter-Empfängergruppe",
    searchLabel: "Suche nach Newsletter-Widget-Titel, Gruppe oder ID"
  },
  newsletter: {
    newsletterLabel: "Newsletter",
    backButton: "Zurück zur Newsletter-Liste",
    newNewsletter: "Neues Newsletter",
    messageDeleteNewsletter: "Newsletter löschen",
    messageDeleteNewsletterTitle: "Sind Sie sicher, dass Sie dieses Newsletter löschen möchten?",
    deleteNewsletter: "Löschen",
    messageDeleted: "Newsletter gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des Newsletters",
    errorFailedLoadedNewsletterWithId: "Es gab einen Fehler beim Abrufen des Newsletters",
    handledInLegacySystem: "Dieser Newsletter wird in {source} behandelt, Sie können ihn nicht auf Vibe bearbeiten",
    errorNewsletterFailedLoad: "Laden fehlgeschlagen {id}",
    newsletterReferrer: "Newsletter Referrer",
    newsletterWidgetName: "Newsletter-Widget-Name",
    tooltipNewsletterReferrer: "Optional parameter which is passed to the newsletter tool in order to track which widget generated a subscription, for example “Sommerkampagne-2024”",
    tooltipNewsletterWidgetName: "Der Newsletter-Widget Titel ist für Besucher der Website nicht sichtbar.",
    template: "Design template",
    headline: "Überschrift",
    text: "Text",
    newsletterWidget: "Newsletter-Widget",
    selectNewsletterWidget: "Newsletter-Widget auswählen",
    tagLine: "Tag Line"
  },
  newsletterEdit: {
    label: "Bezeichnung",
    counter: "Zähler",
    backButton: "Zurück zur Newsletter-Liste",
    editNewsletter: "Newsletter bearbeiten",
    messageSaved: "Neues Newsletter gespeichert"
  }
};
const en = {
  newsletterApi: {
    createAlreadyExists: "Can't create Newsletter because another Newsletter with this name already exists",
    updateAlreadyExists: "Can't update Newsletter because another Newsletter with this name already exists",
    created: "Newsletter created",
    updated: "Newsletter updated",
    notFound: "Newsletter not found",
    requiredFields: "You can't save the Newsletter because mandatory information is missing"
  },
  newsletterList: {
    newButton: "New newsletter widget",
    name: "Search by label",
    deleteNewsletter: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Newsletter",
    headerLabel: "Label",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createNewsletter: "Create Newsletter",
    newsletterWidgetName: "Newsletter widget name",
    newsletterRecipientGroup: "Newsletter recipient group",
    searchLabel: "Search by newsletter widget name, group or ID"
  },
  newsletter: {
    newsletterLabel: "Newsletter",
    backButton: "Back to Newsletter list",
    newNewsletter: "New Newsletter",
    messageDeleteNewsletter: "Delete Newsletter",
    messageDeleteNewsletterTitle: "Are you sure you want to delete this Newsletter?",
    deleteNewsletter: "Delete",
    messageDeleted: "Newsletter Deleted",
    errorOnDeleting: "There was an error deleting the Newsletter ",
    errorFailedLoadedNewsletterWithId: "There was an error getting the Newsletter",
    handledInLegacySystem: "This Newsletter is being handled in {source}, you can't edit it on Vibe",
    errorNewsletterFailedLoad: "Failed to load {id}",
    newsletterWidgetName: "Newsletter widget name",
    newsletterReferrer: "Newsletter referrer",
    tooltipNewsletterReferrer: "Optional parameter which is passed to the newsletter tool in order to track which widget generated a subscription, for example “Sommerkampagne-2024”",
    tooltipNewsletterWidgetName: "The newsletter widget title is not visible to visitors of the website.",
    template: "Design Template",
    headline: "Headline",
    text: "Text",
    newsletterWidget: "Newsletter Widget",
    selectNewsletterWidget: "Select newsletter widget",
    tagLine: "Tag line"
  },
  newsletterEdit: {
    label: "Label",
    counter: "Counter",
    backButton: "Back to Newsletter list",
    editNewsletter: "Edit Newsletter",
    messageSaved: "New Newsletter saved"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/newsletter",
    children: [
      {
        path: "",
        name: "newsletter_list",
        component: () => import("./newsletter-list.view-LapRqp8V.js"),
        meta: { requiredRight: "navigate_list_newsletter" }
      },
      {
        path: "new",
        name: "newsletter_new",
        component: () => import("./newsletter-edit.view-BF--wxgI.js"),
        props: () => ({
          title: getI18n().t("newsletter.newNewsletter"),
          backRoute: "/newsletter"
        }),
        meta: { requiredRight: ["navigate_newsletter"] }
      },
      {
        path: ":id",
        name: "newsletter_detail",
        component: () => import("./newsletter-edit.view-BF--wxgI.js"),
        props: (route) => ({
          title: getI18n().t("newsletterEdit.editNewsletter"),
          id: route.params.id,
          backRoute: "/newsletter"
        }),
        meta: { requiredRight: ["navigate_newsletter"] }
      }
    ]
  }
];
const NewsletterContentBlock = defineAsyncComponent(() => import("./newsletter-content-block-CcvcXfeo.js"));
const newsletterModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "NEWSLETTER",
      label: "newsletter.newsletterWidget",
      icon: "mail",
      component: NewsletterContentBlock,
      defaultValue: { type: "NEWSLETTER" }
    }
  ]
};
export {
  NewsletterContentBlock,
  newsletterModule
};
//# sourceMappingURL=index.es.js.map
